import { render } from "./CRMWhatsappProductFollowupHistoryDialog.vue?vue&type=template&id=267bb5a2&scoped=true"
import script from "./CRMWhatsappProductFollowupHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappProductFollowupHistoryDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappProductFollowupHistoryDialog.vue?vue&type=style&index=0&id=267bb5a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267bb5a2"]])

export default __exports__